import { useCallback, useMemo } from 'react';

import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { getMinimalCartEntryType } from '../utils';

export const useCartEntryType = (entryId: string) => {
  const getCartEntryType = useCartEntryTypeFn();
  return useMemo(() => getCartEntryType(entryId), [getCartEntryType, entryId]);
};

export const useCartEntryTypeFn = () => {
  const { indexedMenu, indexedOffers, indexedRewards } = useUnifiedMenuContext();

  return useCallback(
    (entryId: string) => {
      return getMinimalCartEntryType(entryId, { indexedMenu, indexedOffers, indexedRewards });
    },
    [indexedMenu, indexedOffers, indexedRewards]
  );
};
